<template>
  <div>
    <rename-template-modal ref="renameTemplateModal" />
    <share-template-modal ref="shareTemplateModal" />
    <save-template-modal />
    <duplicate-template-modal ref="duplicateModal" />
    <conflict-template-modal />
    <unsaved-template-modal ref="unsavedWarningModal" />
    <tags-modal ref="tagsModal" />
    <template-tags-modal ref="templateTagsModal" />
    <success-modal />
    <use-template-modal />
    <delete-template-modal ref="deleteTemplateModal" />
    <merge-tags-sources-modal ref="mergeTagsSourceModal" />
    <display-conditions-modal />
    <download-template-modal ref="downloadTemplateModal" />
    <delete-tags-modal />
    <dynamic-contents-modal />
    <external-content-urls-modal />
    <conflict-row-category-modal />
    <save-row-modal />
    <send-test-modal :sendClient="sendClient" />
  </div>
</template>

<script>
import SaveTemplateModal from './modals/SaveTemplateModal.vue';
import RenameTemplateModal from './modals/RenameTemplateModal.vue';
import DuplicateTemplateModal from './modals/DuplicateTemplateModal.vue';
import DeleteTemplateModal from './modals/DeleteTemplateModal.vue';
import ConflictTemplateModal from './modals/ConflictTemplateModal.vue';
import UnsavedTemplateModal from './modals/UnsavedTemplateModal.vue';
import SuccessModal from './modals/SuccessModal.vue';
import UseTemplateModal from './modals/UseTemplateModal.vue';
import ShareTemplateModal from './modals/ShareTemplateModal.vue';
import MergeTagsSourcesModal from './modals/MergeTagsSourcesModal';
import DisplayConditionsModal from './modals/DisplayConditionsModal';
import DownloadTemplateModal from './modals/DownloadTemplateModal';
import TagsModal from './modals/TagsModal.vue';
import TemplateTagsModal from './modals/TemplateTagsModal.vue';
import DeleteTagsModal from './modals/DeleteTagsModal.vue';
import DynamicContentsModal from './modals/DynamicContentsModal.vue';
import ExternalContentUrlsModal from './modals/ExternalContentUrlsModal.vue';
import ConflictRowCategoryModal from './modals/ConflictRowCategoryModal.vue';
import SaveRowModal from './modals/SaveRowModal.vue';
import SendTestModal from './modals/SendTestModal.vue';
import SendClient from './dynamic-contents/sendClient.js';

export default {
  name: 'ModalContainer',
  components: {
    SaveTemplateModal,
    RenameTemplateModal,
    DuplicateTemplateModal,
    DeleteTemplateModal,
    ConflictTemplateModal,
    UnsavedTemplateModal,
    SuccessModal,
    UseTemplateModal,
    ShareTemplateModal,
    MergeTagsSourcesModal,
    DisplayConditionsModal,
    DownloadTemplateModal,
    TagsModal,
    TemplateTagsModal,
    DeleteTagsModal,
    DynamicContentsModal,
    ExternalContentUrlsModal,
    ConflictRowCategoryModal,
    SaveRowModal,
    SendTestModal
  },
  data: function () {
    return {
      sendClient: SendClient(process.env.VUE_APP_SEND_API)
    };
  },
  methods: {
    unsavedWarning: function (template) {
      this.$refs.unsavedWarningModal.open(template);
    },
    openDeleteModal: function (template) {
      this.$refs.deleteTemplateModal.open(template);
    },
    duplicateModal: function (template) {
      this.$refs.duplicateModal.open(template);
    },
    onRenameTemplate: function (template) {
      this.$refs.renameTemplateModal.open(template);
    },
    shareModal: function (template) {
      this.$refs.shareTemplateModal.open(template);
    },
    mergeTagsModal: function (template) {
      this.$refs.mergeTagsSourceModal.open(template);
    },
    downloadTemplate: function (template) {
      this.$refs.downloadTemplateModal.open(template);
    },
    tagsModal: function () {
      this.$refs.tagsModal.open();
    },
    templateTagsModal: function (templateId) {
      this.$refs.templateTagsModal.open(templateId);
    }
  }
};
</script>

<style scoped></style>
